import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { UserInfos } from "../../../shared/ui/username-icon/user-infos.type";
import { UsernameIconComponent } from "../../../shared/ui/username-icon/username-icon.component";
import { TimelineItemType, TopicType } from "@teammood/timeline";

@Component({
    selector: 'anonymity-preview',
    templateUrl: 'anonymity-preview.component.html',
    styleUrls: ['anonymity-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        UsernameIconComponent
    ]
})
export class AnonymityPreviewComponent implements OnInit{

    protected itemTypeText: string;

    @Input() isAnonymous: boolean; 
    @Input() userInfos: UserInfos;
    @Input() itemType: TopicType | TimelineItemType;
  
    constructor() {}

    ngOnInit(): void {
        switch(this.itemType){
            case 'kudosItem': 
                this.itemTypeText = 'timeline-item-creation-dialog.kudos';
                break;
            case 'issue': 
                this.itemTypeText = 'timeline-item-creation-dialog.issue';
                break;
            case 'question': 
                this.itemTypeText = 'timeline-item-creation-dialog.question';
                break;
        }
    }
}
